import { type Locale } from '@/core/tamagoshiTailwind/interfaces';
import { getLocale } from '@/domains/core/settings/utils';

const getFormatterLocale = (locale: Locale): Locale =>
  locale === 'es-ES' ? 'de-DE' : locale;

export const formatPrice = (price: number) => {
  const locale: Locale = getLocale();
  return new Intl.NumberFormat(getFormatterLocale(locale), {
    style: 'currency',
    currency: locale === 'en-GB' ? 'GBP' : 'EUR',
  })
    .format(price)
    .replace(/\s(?=€)/g, '');
};
